$(document).ready(function(){
  var isPreCart = getParameterByName('preCart');
  var ringSizeSelected = getParameterByName('ringSize');
  var grabRawDiamondInfo = localStorage.getItem("_raw_diamond_info")
  if(isPreCart === 'true' && grabRawDiamondInfo) {
    $('.bespoke-pre-cart-form').removeClass('hide')
    $('.product__description').addClass('hide')
    //$('#accordion-first-item').addClass('hide')
    $('#bespoke-policy').removeClass('hide')
    $('.bespoke-pre-cart-banner').removeClass('hide')
    $('.bespoke-pdp-banner').addClass('hide')
  } else {
    $('.bespoke-product-form').removeClass('hide')
    //$('#accordion-first-item').removeClass('hide')
    $('#bespoke-policy').addClass('hide')
    $('.bespoke-pre-cart-banner').addClass('hide')
    $('.bespoke-pdp-banner').removeClass('hide')
  }
  if(grabRawDiamondInfo){
    $('#reviewYourDesignBtn').removeClass('hide');
    $('.Diomand-stack-shape, #diamondShapeLabel').addClass('hide');
    $('.selected-diamond-info-pdp').removeClass('hide')
  } else {
    $('#selectThisSettingBtn').removeClass('hide');
    $('.Diomand-stack-shape, #diamondShapeLabel').removeClass('hide');
    $('.selected-diamond-info-pdp').addClass('hide')
  }

  if(ringSizeSelected && ringSizeSelected !== '') {
    $('#selectDiamondPageLink, #reviewYourDesignPageLink').removeClass('choose-settings-grey-btn')
    $('#chooseDiamond, #reviewYourDesignPageLink').addClass('show-hand-cursor');
  } else {
    $('#selectDiamondPageLink, #reviewYourDesignPageLink').addClass('choose-settings-grey-btn')
    $('#chooseDiamond').removeClass('show-hand-cursor');
  }
  
  /* ===== Checking the users selected Diamond and removing if current setting doesn't contains the selected Diamond Shape ===== */
  var grabSelectedDiamondData = localStorage.getItem("_raw_diamond_info");
  var rawDiamondInfo = JSON.parse(grabSelectedDiamondData);
  var selectedDiamondShape = rawDiamondInfo?.diamondShape?.replace(/-/g, '').toLowerCase();
  if(selectedDiamondShape === "antiquestyle round") selectedDiamondShape = "antique style round";
  if(selectedDiamondShape === "emerald+(north/south)") selectedDiamondShape = "emerald (north/south)";
  if(selectedDiamondShape === "emerald+(east/west)") selectedDiamondShape = "emerald (east/west)";
  
  var cleanedDiamondShapesInProduct = diamondShapesInProduct.map(shape => shape.replace(/-/g, ' ').toLowerCase()); // "diamondShapesInProduct" is defined in product-form-for-vow-template-new.liquid file
  var containsSelectedDiamondShape = cleanedDiamondShapesInProduct.includes(selectedDiamondShape);
  if (containsSelectedDiamondShape === false) {
    removeVowLocalstorageItems();
    $('#reviewYourDesignBtn').addClass('hide');
    $('#selectThisSettingBtn').removeClass('hide');
    $('#step-three-review-design, #step-one-choose-diamond').removeClass('selected');
    $('#selectedSettingThreeStep, #viewChangeSetting, #totalCostCalculator').remove();
    $('.Diomand-stack-shape, #diamondShapeLabel').removeClass('hide');
    $('.selected-diamond-info-pdp').addClass('hide')
  }
})

function playFile() {
  var video = $("#videoID");
  if (video.length && video[0].play()) {
    video[0].load();
    video[0].play();
  }
};

/* Redirecting to Pre Cart */
function redirectToReviewYourDesign() {
  var redirectString = window.location.href;
  var url = new URL(redirectString);
  var params = new URLSearchParams(url.search);
  if (params.has('preCart')) {
    params.set('preCart', 'true');
  } else {
    params.append('preCart', 'true');
  }
  var grabProductTitle = currentProductJson.title;
  var grabProductPrice = removeDoller($('#actualSettingprice').text())*100;
  var hideMarquiseDiamond = false;
  if (currentProductJson.tags.includes('hide-marquise-diamond')) hideMarquiseDiamond = true;
  localStorage.setItem( 'selectedSettingInfo', JSON.stringify({grabProductTitle, grabProductPrice, hideMarquiseDiamond}) )
  window.location.href = url.origin + url.pathname + '?' + params.toString();
}

function getVariantVideoUrl(productId) {
  var body = {
    apiUrl: apiUrlPath + apiVersion + "products/" + productId + "/metafields.json?limit=250",
    method: 'GET'
  }
  commonApiCalls(body, (data) => {
    var result = data;
    if (result) {
      var selectedVariantId = getParameterByName('variant', window.location.href);
      var variantVideo = $.map(result.metafields, vari => {
        if (vari.key.indexOf(selectedVariantId) !== -1 && vari.description === "product_variant_video") return vari
      });
      var video = $('#videoID');
      video.addClass('Image--lazyLoad')
      video.html('');
      if (variantVideo.length) {
        var videoUrl = variantVideo[0].value;
        var html = "<source src='" + videoUrl + "' type='video/mp4' />";
        html += "<source src='" + videoUrl + "' type='video/mov' />";
        html += "<source src='" + videoUrl + "' type='video/ogg' />";
        video.html(html);
        $(".VideoWrapper").removeClass('close')
        video.removeClass('Image--lazyLoad')
        setTimeout(() => {
          video[0].pause();
          playFile();
        }, 500)
      } else {
        $(".VideoWrapper").addClass('close')
        video.removeClass('Image--lazyLoad')
      }
    }
  })
}

/* Custom Scripts */
var video = $('.videoPlayer1')[0];
$(video).trigger('play');

productDetailTabSwitch = ($this, tabName) => {
  $('.ProductTabList').removeClass('active');
  $('.productTabData').hide();
  $($this).addClass('active');
  $("."+tabName).show();
}

var productStartingPrice = 0;
var productId = currentProductJson.id
var productVal = currentProductJson

// iphone player
function enableInlineVideo(){"use strict";function e(e,i,n){function r(r){n&&!n(e,i)||r.stopImmediatePropagation()}return e.addEventListener(i,r),r}function i(e,i,n,r){function t(e){n[i]=e}r&&t(e[i]),Object.defineProperty(e,i,{get:function(){return n[i]},set:t})}function n(e,i,n){n.addEventListener(i,function(){return e.dispatchEvent(new Event(i))})}function r(e,i){Promise.resolve().then(function(){e.dispatchEvent(new Event(i))})}function t(e,i,n){(v||0)+200<Date.now()&&(e[f]=!0,v=Date.now()),n||(e.currentTime=i),g[++h%3]=100*i|0}function d(e){return e.driver.currentTime>=e.video.duration}function a(){var e=this,i=e[l];e.webkitDisplayingFullscreen?e[y]():("data:"!==i.driver.src&&i.driver.src!==e.src&&(t(e,0,!0),i.driver.src=e.src),e.paused&&(i.paused=!1,0===e.buffered.length&&e.load(),i.driver.play(),i.updater.start(),i.hasAudio||(r(e,"play"),i.video.readyState>=i.video.HAVE_ENOUGH_DATA&&r(e,"playing"))))}function u(e){var i=this,n=i[l];n.driver.pause(),n.updater.stop(),i.webkitDisplayingFullscreen&&i[m](),n.paused&&!e||(n.paused=!0,n.hasAudio||r(i,"pause"),i.ended&&!i.webkitDisplayingFullscreen&&(i[f]=!0,r(i,"ended")))}function o(e,i){var a={};e[l]=a,a.paused=!0,a.hasAudio=i,a.video=e,a.updater=function(e){return function(e,i,n,r){function t(n){d=i(t,r),e(n-(a||n)),a=n}var d,a;return{start:function(){d||t(0)},stop:function(){n(d),d=null,a=0}}}(e,requestAnimationFrame,cancelAnimationFrame)}(function(e){var i=this;i.video.readyState>=i.video.HAVE_FUTURE_DATA?(i.hasAudio||(i.driver.currentTime=i.video.currentTime+e*i.video.playbackRate/1e3,i.video.loop&&d(i)&&(i.driver.currentTime=0)),t(i.video,i.driver.currentTime)):i.video.networkState===i.video.NETWORK_IDLE&&0===i.video.buffered.length&&i.video.load(),i.video.ended&&(delete i.video[f],i.video.pause(!0))}.bind(a)),i?a.driver=function(e){var i=new Audio;return n(e,"play",i),n(e,"playing",i),n(e,"pause",i),i.crossOrigin=e.crossOrigin,i.src=e.src||e.currentSrc||"data:",i}(e):(e.addEventListener("canplay",function(){e.paused||r(e,"playing")}),a.driver={src:e.src||e.currentSrc||"data:",muted:!0,paused:!0,pause:function(){a.driver.paused=!0},play:function(){a.driver.paused=!1,d(a)&&t(e,0)},get ended(){return d(a)}}),e.addEventListener("emptied",function(){var n=!a.driver.src||"data:"===a.driver.src;a.driver.src&&a.driver.src!==e.src&&(t(e,0,!0),a.driver.src=e.src,n||!i&&e.autoplay?a.driver.play():a.updater.stop())},!1),e.addEventListener("webkitbeginfullscreen",function(){e.paused?i&&0===a.driver.buffered.length&&a.driver.load():(e.pause(),e[y]())}),i&&(e.addEventListener("webkitendfullscreen",function(){a.driver.currentTime=e.currentTime}),e.addEventListener("seeking",function(){g.indexOf(100*e.currentTime|0)<0&&(a.driver.currentTime=e.currentTime)}))}function s(e){var i=e[f];return delete e[f],!e.webkitDisplayingFullscreen&&!i}function c(n){var r=n[l];n[y]=n.play,n[m]=n.pause,n.play=a,n.pause=u,i(n,"paused",r.driver),i(n,"muted",r.driver,!0),i(n,"playbackRate",r.driver,!0),i(n,"ended",r.driver),i(n,"loop",r.driver,!0),e(n,"seeking",function(e){return!e.webkitDisplayingFullscreen}),e(n,"seeked",function(e){return!e.webkitDisplayingFullscreen}),e(n,"timeupdate",s),e(n,"ended",s)}var v,p="object"==typeof document&&"object-fit"in document.head.style&&!matchMedia("(-webkit-video-playable-inline)").matches,l="bfred-it:iphone-inline-video",f="bfred-it:iphone-inline-video:event",y="bfred-it:iphone-inline-video:nativeplay",m="bfred-it:iphone-inline-video:nativepause",g=[],h=0;return function(e,i){if(void 0===i&&(i={}),!e[l]){if(!i.everywhere){if(!p)return;if(!(i.iPad||i.ipad?/iPhone|iPod|iPad/:/iPhone|iPod/).test(navigator.userAgent))return}e.pause();var n=e.autoplay;e.autoplay=!1,o(e,!e.muted),c(e),e.classList.add("IIV"),e.muted&&n&&(e.play(),e.addEventListener("playing",function i(){e.autoplay=!0,e.removeEventListener("playing",i)})),/iPhone|iPod|iPad/.test(navigator.platform)||console.warn("iphone-inline-video is not guaranteed to work in emulated environments")}}}

// mobile image preview when user client on plus button
$(".enlarge-mobile").on('click', function(event){
  var imageIndex = $(".flickity-page-dots").find("li.is-selected").index()
  var imageid = $(".flickity-slider").find(".Product__SlideItem--image:eq("+(imageIndex)+")").attr('data-image-id')	
  $("#Image" + imageid).trigger('click')
});

// mobile image preview when user client on plus button
callonPageLoad(productId)

// Player JS 
$('.videoPlayerButton').click(function() {
  var videoPlayer = $(this).parent().parent().find("video")
  var video = videoPlayer[0];
  if (video.paused == true) {
    $(video).trigger('play');
    $(this).removeClass('iconPlay').addClass('iconPause');
  } else {
    $(video).trigger('pause');
    $(this).removeClass('iconPause').addClass('iconPlay');
  }
})

// One video
var video = document.querySelector('video');
enableInlineVideo(video);

// Close Drawer
$('.shipping-header-close, .shipping-drawer-backdrop').click(function() {
  $('#specsDrawer').removeClass('open');
  $('.shipping-drawer-backdrop').hide();
  $("body").css("overflow","overlay");
  $('.shipping-header-close').blur();
  $('#specsDrawer').off('keydown', trapFocus);
});

function trapFocus(e) {
const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
const focusableElements = $('#specsDrawer').find(focusableElementsString).get();
const firstFocusableElement = focusableElements[0];
const lastFocusableElement = focusableElements[focusableElements.length - 1]; 
  if (e.key === 'Tab') {
    if (e.shiftKey) { 
      if (document.activeElement === firstFocusableElement) {
        e.preventDefault();
        lastFocusableElement.focus();
      }
    } else { 
      if (document.activeElement === lastFocusableElement) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    }
  } else if (e.key === 'Escape') {
    $('#specsDrawer').removeClass('open');
    $('.shipping-drawer-backdrop').hide();
    $("body").css("overflow","overlay");
    $('.shipping-header-close').blur();
    $('#specsDrawer').off('keydown', trapFocus);
  }
}

// Reviews Summary
var reviewSumm = $('.spr-summary').html();
$('.summaryCustom').html(reviewSumm);
$('.summaryCustom').find('.spr-summary-actions').hide();

function callonPageLoad(productId) {
  var defaultDiamondShape = getDiamondType()
  if(!defaultDiamondShape) {
    defaultDiamondShape = currentVariantJson.option1
  }
  getVariantVideoUrl(productId);
  setTimeout(() => {
    let basePrice = currentVariantJson.price
    productStartingPrice = basePrice;
    makeVariantSelectedPrice(basePrice)
  }, 100)
}

if (document.getElementById("myVideo") && document.getElementById("myVideo").length) {
  document.getElementById("myVideo").controls = true;
}